import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

function deviceId() {
  let did = localStorage.getItem("device_id");
  if (!did) { did = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : `${Date.now()}-${Math.random()}`; localStorage.setItem("device_id", did); }
  return did;
}
export function isMobileClient() {
  return (typeof window !== "undefined" && window.matchMedia && window.matchMedia("(max-width: 820px)").matches) ? "1" : "0";
}
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  config.headers["X-Device-Id"] = deviceId();
  config.headers["X-Client-Mobile"] = isMobileClient();
  const env = localStorage.getItem("activeEnvId");
  if (env) config.headers["X-Env-Id"] = env;
  return config;
});

export function getToken() {
  return localStorage.getItem("token");
}

export function photoUrl(photoId, token) {
  const t = token || localStorage.getItem("token");
  return `${API}/photos/${photoId}/file?auth=${t}`;
}

export function kbFileUrl(path, token) {
  const t = token || localStorage.getItem("token");
  return `${API}/kb/file?path=${encodeURIComponent(path)}&auth=${t}`;
}

export function kbExportUrl(aid, token) {
  const t = token || localStorage.getItem("token");
  return `${API}/kb/articles/${aid}/export-pdf?auth=${t}`;
}

export const deviceApi = axios.create({ baseURL: API });
deviceApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("deviceToken");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const env = localStorage.getItem("deviceEnvId");
  if (env) config.headers["X-Env-Id"] = env;
  return config;
});

export const monitorApi = axios.create({ baseURL: API });
monitorApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("monitorToken");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const env = localStorage.getItem("monitorEnvId");
  if (env) config.headers["X-Env-Id"] = env;
  return config;
});

export const pagerApi = axios.create({ baseURL: API });
pagerApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("pagerToken");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const env = localStorage.getItem("pagerEnvId");
  if (env) config.headers["X-Env-Id"] = env;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Er ging iets mis. Probeer opnieuw.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
